var styles = ["[_nghost-%COMP%]   .menu-sidebar[_ngcontent-%COMP%]     .scrollable{padding-top:var(--layout-padding-top)}"];
export { styles as styles };
